/**
 * Utility function to extract product variants information from the provided Product Detail Data.
 *
 * @param productVariationAttributes - The product variation attributes.
 * @param formatMessage - Function for formatting messages.
 * @returns A string indicating the availability of product variant sizes or colors.
 */
/**
 * Derives the effective image host from a given hostname.
 * Strips any partner prefix (e.g. "wex-fsa.devhec.com" → "fsa.devhec.com").
 * Hosts without a dash-prefixed subdomain are returned unchanged.
 */
export const getImageHost = (hostname: string): string => {
    return hostname
        .replace(/^[^.-]+-/, '') // strip partner prefix: wex-fsa.devhec.com → fsa.devhec.com
        .replace(/^([^.-]+)test\./, '$1.') // strip test suffix:    fsatest.devhec.com → fsa.devhec.com
}

export const extractProductVariantsInfo = (
    productVariationAttributes: {name?: string; values?: {value?: string}[]}[] | undefined,
    formatMessage: (message: {defaultMessage: string; id: string}) => string
): string => {
    // Extract variationAttributes data
    const variationAttributes = productVariationAttributes ?? []

    // Extract the fields you requested
    const variationAttributesLength = variationAttributes.length
    const firstVariationDisplayName = variationAttributes[0]?.name ?? ''
    const firstVariationValuesLength = variationAttributes[0]?.values?.length ?? 0
    let productVariantsInfo = ''

    if (variationAttributesLength > 0 && firstVariationValuesLength > 1) {
        if (variationAttributesLength > 1) {
            productVariantsInfo = formatMessage({
                defaultMessage: 'More Options Available',
                id: 'product_tile.label.more.options.available'
            })
        } else {
            productVariantsInfo =
                `${firstVariationValuesLength} ${firstVariationDisplayName}` +
                formatMessage({
                    defaultMessage: 's Available',
                    id: 'product_tile.label.single.option.available'
                })
        }
    }

    return productVariantsInfo
}
